import { useMemo } from 'react';
import { useAppContext } from './context.tsx';
import type { TagState } from './types.tsx';

function capitalize(str) {
  return str
    .toLowerCase()
    .split(" ")
    .map(word => {
      if (word.length === 0) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}

export const useWizardTags = (): TagState[] => {
  const { state } = useAppContext();

  return useMemo(() => [
    {
      label: "Country",
      checked: !!state.selectedCountry,
      value: state.selectedCountry || undefined,
    },
    {
      label: "Region",
      checked: !!state.selectedRegion,
      value: state.selectedRegion || undefined,
    },
    {
      label: "District",
      checked: !!state.selectedDistrict,
      value: capitalize(state.selectedDistrict) || undefined,
    },
    {
      label: "Goal",
      checked: !!state.selectedObjective,
      value: state.selectedObjective || undefined,
    },
    {
      label: "Category",
      checked: !!state.selectedWasteCategory,
      value: state.selectedWasteCategory || undefined,
    },
    {
      label: "Waste Type",
      checked: !!state.selectedWasteType,
      value: state.selectedWasteType || undefined,
    },
    {
      label: "Value Added Product",
      checked: !!state.selectedBusinessModel,
      value: state.selectedBusinessModel || undefined,
    },
    {
      label: "Business Models",
      checked: state.selectedBusinessModels.length > 0,
      value:
        state.selectedBusinessModels.length > 0
          ? `${state.selectedBusinessModels.length} selected`
          : undefined,
    },
    {
      label: "Location",
      checked: !!state.plantLocation,
      value: state.plantLocation?.name || undefined,
    },
  ], [state]);
};
